const ruMessages = {
  /* 01.General */

  "main.name": "Имя",
  "main.sentiment": "Настроение",
  "main.urgency": "Срочность",
  "main.language": "Язык",
  "main.agent": "Агент",
  "main.property_name": "Название объекта",
  "main.booking_number": "Номер бронирования",
  "main.check_out": "Выезд",
  "main.check_in": "Заезд",
  "main.adults": "Взрослые",
  "main.corporate_code": "Корпоративный код",
  "main.group_code": "Код группы",
  "main.promo_code": "Промокод",
  "main.ai_response": "Ответ ИИ",
  "main.template_response": "Ответ шаблона",
  "main.converttoticket": "Преобразовать в заявку",
  "main.switch_property": "Сменить объект",
  "main.Group_id": "ID группы",
  "main.integration_id": "ID интеграции",
  "main.submit": "Отправить",
  "main.cancel": "Отмена",
    "main.select_template": "Выберите шаблон",
  "main.rooms": "Номера",
  "main.rates": "Тарифы",

  //footer
  
  "footer.knowledge": "Знания",
  "footer.home": "Главная",
  "footer.help": "Помощь",

  //ticket
  "ticket.thank_you": "Спасибо за отправку формы",
  "ticket.ticket": "Заявка",
  "ticket.details": "Пожалуйста, заполните форму с описанием деталей заявки.",
  "ticket.select_category": "Выберите категорию",
  "ticket.category": "Категория",
  "ticket.title": "Заголовок",
  "ticket.notes": "Примечания",
  "ticket.status": "Статус",
  "ticket.assigned_to": "Назначено",
  "ticket.submit_form": "Отправить форму",

  
  "main.total": "Итого",
  "main.pastetooutlook": "Вставить в Outlook",
  "main.children": "Дети",
  "main.promocode": "Промокод/Корпоративный/Групповой код",
  "main.exact_match_only": "Только точное совпадение",
  "main.search": "Поиск",
  "main.no_rate_match": "Нет тарифов, соответствующих вашему выбору. Измените параметры поиска и попробуйте снова.",
  "main.translate_to": "Перевести на",
  "main.regenerate": "Создать заново",
  "main.copy_text": "Копировать текст",
  "main.additional_instructions": "Дополнительные инструкции",

  "faq.helpcenter": "Центр помощи",
  "faq.reply.email.sabre.question": "Как ответить на электронное письмо с помощью автоматизации электронной почты Aven Hospitality Concierge?",
  "faq.reply.email.sabre.answer": "Откройте письмо и запустите надстройку Aven Hospitality. Вы можете выбрать один из трех вариантов: использовать готовый шаблон, создать ответ с помощью ИИ или преобразовать письмо в заявку. Выберите подходящий вариант, проверьте ответ, внесите изменения при необходимости и отправьте его напрямую из Outlook.",

  "faq.rates.availability.question": "Как добавить тарифы, доступность и данные о номерах в мой ответ?",
  "faq.rates.availability.answer": "Используйте функцию + Rates для ввода данных гостя, таких как даты и количество гостей. Concierge добавит точную доступность и цены в ваш ответ. Также можно использовать + Rooms для добавления описаний номеров и изображений.",

  "faq.different.language.question": "Что делать, если письмо написано на другом языке?",
  "faq.different.language.answer": "Aven Hospitality Concierge позволяет переводить входящие письма на предпочитаемый язык, после чего можно создать или отредактировать ответ и перевести его обратно на язык гостя перед отправкой.",

  "faq.pin.addin.question": "Как убедиться, что надстройка всегда доступна в Outlook?",
  "faq.pin.addin.answer": "Закрепите надстройку Aven Hospitality Concierge в Outlook, чтобы она всегда отображалась и открывалась автоматически.",

  "faq.knowledge.hub.question": "Что такое поиск Knowledge Hub?",
  "faq.knowledge.hub.answer": "Поиск Knowledge Hub позволяет быстро находить информацию об объекте непосредственно в Outlook.",

  "faq.reply.email.myma.question": "Как ответить на письмо с помощью Myma?",
  "faq.reply.email.myma.answer": "Откройте письмо и запустите надстройку Myma. Вы можете использовать шаблон, создать ответ с помощью ИИ или преобразовать письмо в заявку.",

  "faq.room.details.question": "Как добавить информацию о номере в мой ответ?",
  "faq.room.details.answer": "Используйте + Rooms для добавления описаний номеров и изображений.",

  "faq.myma.different.language.question": "Что делать, если письмо написано на другом языке?",
  "faq.myma.different.language.answer": "Myma позволяет переводить входящие письма на предпочитаемый язык.",

  "faq.myma.pin.addin.question": "Как убедиться, что надстройка всегда доступна в Outlook?",
  "faq.myma.pin.addin.answer": "Закрепите надстройку Myma в Outlook, чтобы она автоматически открывалась с каждым письмом.",

};
export default ruMessages;